import store from '@/services/Store';
import axios, { Method } from 'axios';
import moment from 'moment';
import { ICustomResponse } from '@/interfaces/ICustomResponse';
import {DropDownItem, SelectDropDownItem} from '@/services/DropDownItem';
import { ClaimEnum } from './ClaimEnum';
import { loadLanguageAsync } from '@/i18n/i18n-setup';
import { i18n } from '@/i18n/i18n-setup';
import { Process } from '@/entity/Process';
import { IStoreUser } from '@/interfaces/IStoreUser';
import VueRouter, { Route } from 'vue-router';
import { CONTRACT_TYPE_ENUM } from './Enums';

//TODO: trovare una soluzione per centralizzare lo stato di default
const defaultState = (currentVersion = null) => {
    return {
        token: '',
        user: {} as IStoreUser,
        userProfile: {},
        countrySelected: {},
        claimsList: [],
        isLogged: false,
        currentPath: '',
        isMainLoading: false,
        impersonatedBy: null,
        impersonationStartDate: null,
        userToImpersonate: null,
        clientVersion: currentVersion,
        mandatoryCommunications: null,
        isHidingCommunicationDuringImpersonation: false,
        isEmergencyContactExpired: null,
        processList: [] as Array<Process>,
        processCount: 0,
        lastTranslationUpdate: null,
        languages: [] as Array<any>,
        singleMenuItem: null
    };
};


export class General {
    

    private static ApiUrl: string | undefined = process.env.VUE_APP_URL;
    public static GetApiUrl(url: string) {
        return General.ApiUrl + url;
    }
    public static showAlertDanger(text: string, app: any, errorMessage: string = "") {       
        app.$fire({
            title: "Error",
            text: (errorMessage != "" ? errorMessage : text),
            type: "error"
        })
    }
    public static showAlertDangerAsHTML(text: string, app: any) {        
        app.$fire({
            title: "Error",
            html: text,
            type: "error"
        })
    }
    public static showAlertDangerAsJson(customResponse: ICustomResponse, app: any) {        
        let message:string = '';
        if (customResponse.errors!=null && customResponse.errors.length>0){
            customResponse.errors.forEach(element => {
                message+=element+"<br/>\n";
            });

        }else{
            message = "Undefined";
        }
 
        app.$fire({
            title: "Error",
            html: message,
            type: "error"
        })
    }
    public static HandleError(error: any, app: any, detailedError: boolean = false) {
        if(error.response != undefined) {
           
            if (error.response.status == 460) {
                General.Logout();
            } else {
                if (app != null)
                    General.showAlertDanger(error, app, (detailedError ? (error.response.data.errors != undefined ? "" : error.response.data) : ""));
            }
        }
    }
    public static HandleErrorAsHTML(error: any, app: any) {
        if (error.response.status == 460) {
            General.Logout();
        } else {
            if (app != null)
                General.showAlertDangerAsHTML(error, app);
        }
    }

    public static fillArraySeparator(array: string[], separator: string) {
        let string = '';
        array.forEach(function (item, index) {
            if (index != array.length - 1)
                string += item + separator;
            else string += item;
        });
        return string;
    }

    public static showAlertInfo(text: string, app: any) {
        app.$fire({
            //title: "Info",
            text: text,
            //type: "warning"
        })
    }
    public static showAlertSuccess(text: string, app: any) {
        app.$toastr.s(
            text
        );
        /*
        app.$fire({
            title: "Success",
            text: text,
            type: "success"
        })
        */
        
    }

    public static getFileNameFromHeader(headers) {
        return headers['content-disposition'].split(';')
            .find(n => n.includes('filename='))
            .replace('filename=', '')
            .trim();
    }

    public static getDocumentUrl(idDocument: any) {
        return General.GetApiUrl("/api/document/DownloadDocumentById?documentId=" + idDocument);
    }
    /*
    public static getPackageLabelUrl(materialId: string, packageType: string, pageHeight: string, pageWidth: string, textTopOffset: string, zoom: string, rotation: string, printLogoAndFooter: boolean) {
        return General.GetApiUrl("/api/packagelabel/DownloadPackageLabel?materialId=" + materialId + "&packageType=" + packageType + "&pageHeight=" + pageHeight + "&pageWidth=" + pageWidth + "&textTopOffset=" + textTopOffset + "&zoom=" + zoom + "&rotation=" + rotation + "&printLogoAndFooter=" + printLogoAndFooter as string);
    }
    */
    public static CheckAuthorization(auth: string): boolean {
        let claims = store.state.claimsList;
        if (!claims) return false;
        for (let i = 0; i < claims.length; i++) {
            if (auth == claims[i].claimType)
                return true;
            }
        return false;
    }

    public static CheckAuthorizationAndClaimValue(auth: string, claimValue: string): boolean {
        let claims = store.state.claimsList;
        if (!claims) return false;
        for (let i = 0; i < claims.length; i++) {
            if (auth == claims[i].claimType && claimValue == claims[i].claimValue)
                return true;
            }
        return false;
    }

    public static CanManualProcessProduct(): boolean {
        if (store.getters.getCountrySelected?.countryFather==null ) return false;       
        return !store.getters.getCountrySelected.countryFather.isManagedBySAP;
    }

    public static CanManageLubTable(): boolean {
        return this.CheckAuthorization(ClaimEnum.CanManageLubTable);
    }

    public static Logout() {
        //store.dispatch('logout', {});
        store.replaceState(defaultState(store.getters.checkClientVersion));
    }

    public static truncate(text:string, length:number, suffix:string) {
        if (text.length > length) 
            return text.substring(0, length) + suffix.trim();
         else 
            return text;      
    }
    public static filterProcess(processList:Process[]):Process[]{
        let limit = General.GetLimitDateProcessToView();       
        return processList.filter(
            x=>
                (x.EndDate==null || (new Date(x.EndDate).getTime()>limit.getTime()))                
            );
    }
    public static get currentUsername():string{

        if (store.getters.isImpersonated==true){
            return store.getters.userToImpersonate.toLowerCase();
        }
        return store.getters.getUser.Username.toLowerCase();

    }
    private static CheckIfDifferent(array1: Array<any>, array2: Array<any> ):boolean{      
        if (JSON.stringify(array1)!=JSON.stringify(array2)) return true;
   
        return false;
    }
    public static async IsLogged(app: any) {
        let isLogged: boolean = store.state.isLogged;
        
        if (isLogged) {           
            
            let call = async (response: any) =>  {
                
                let currentLastTranslationDate = new Date(store.getters.getLastTranslationUpdate);
                let lastTranslationUpdate =   new Date(response.data.lastTranslationUpdate);
                
                
                let currentClaims = store.getters.claims;
                if (store.getters.isLogged){
                    let isDifferent = General.CheckIfDifferent(currentClaims,response.data.claims);
                    if(isDifferent){
                        General.showAlertInfo(i18n.t('GENERIC.REENTER_LOGIN') as string, app);
                        General.Logout();
                        
                    
                    }
                }
                if(store.getters.getLastTranslationUpdate != null && lastTranslationUpdate.getTime() != currentLastTranslationDate.getTime() ){     
                    await loadLanguageAsync(store.getters.getUser.IdCulture, true);
                } 
                
                currentLastTranslationDate = response.data.lastTranslationUpdate;
                store.dispatch('setLastTranslationUpdate', currentLastTranslationDate);
               
                store.dispatch('setMandatoryCommunications', response.data.communications);
                 
                let version = store.getters.checkClientVersion;
                if (version == null) {
                    version = response.data.version;
                    store.dispatch('setClientVersion', version);
                }

                if (response.data.version != version) {
                    version = response.data.version;                    
                    store.dispatch('setClientVersion', version);                    
                    General.RefreshPage();
                }
                isLogged = false;
            }

            await General.GetEmergencyContactIfExpiredAsync(); 
            
            General.CallAjax('/api/auth/IsLogged', 'get', null, call);
            if (store.getters.isImpersonated) {
                let startDate = store.getters.impersionationDate;
                
                if (startDate != null) {
                    let currentDate = (new Date(Date.now()));
                    let diffTime = currentDate.getTime() - startDate.getTime();
                    let diffDate = new Date(diffTime);
                    // da aggiungere nelle configurazioni generali
                    if (diffDate.getMinutes() > 40) {
                        General.showAlertInfo("Time for impersonation is ended", app);
                        General.EndImpersonate(app);
                    }
                }
            }

            let processList = store.getters.getProcessList as Process[];
            processList = General.filterProcess(processList);
            store.dispatch('clearProcessList');
            store.dispatch('addProcess',processList);
        }
        return isLogged;
    }

    public static async AuthenticateUser(response: any, route: Route, router: VueRouter) {
        let token = response.data.username;        
        let user = General.BuildUser(token, response.data.claims, response.data.idCulture);        
        let claims = response.data.claims;
        let isLogged = true;        
        let cookieExpiration = response.data.cookieExpiration;
        store.dispatch('login', { token, user, claims, isLogged, cookieExpiration });      
        await General.loadLanguageAsync(response.data.idCulture);           
        await General.SetUser();        

        if(!route.query.from) {
            router.push('/');
        } else {
            let fromUrl = route.query.from as string;
            router.push(fromUrl);
        } 
    }

    public static RefreshPage() {
        window.location.reload();
    }

    public static GoToHomePage(router: any) {
        window.location.href = "/";
        router.push('/');
    }

    public static goToPage(url: string, router: any){
        store.commit("SET_PATH",router.currentRoute.path);
        router.push(url.replace('/:id', '/'));

    }
    public static showSize(size: number): string {
        if (size < 1024) {
            return size.toString() + ' bytes';
        }
        if (size < 1048576) {
            return Math.round(size / 1024).toString() + ' Kb';
        }
        return (size / 1048576).toFixed(1) + ' Mb';
    }
    public static showDate(date: any): string {
        moment.locale('en');
        const diffInHours = Math.abs(moment().diff(date, 'hours'));
        let now;
        if (diffInHours < 2) {
            now = moment(date).fromNow();
        } else {
            now = moment(date).format('lll');
        }
        return now;
    }
    public static formatDateTime(date: Date): string{
        if (date == null) return '';
        return moment(date).format('MM/DD/YYYY HH:mm');
    }
    public static formatDateEng(date: Date): string {
        if (date == null) return '';
        return moment(date).format('MM/DD/YYYY');
    }
    public static formatDateIt(date:Date):string{
        var result = moment(date).format('DD/MM/YYYY');
        return result;
    }
    public static mainLoading(active: boolean): void {
        store.dispatch('setLoading', active);
    }
    public static confirm(message: string, vueApp: Vue, okFunc: () => any) {
        vueApp.$bvModal.msgBoxConfirm(message, {
            title: 'Please Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        }).then(value => {
            if (value) okFunc();
        })
    }
    public static confirmWithNoFunction(message: string, vueApp: Vue, okFunc: () => any, noFunc: () => any) {
        vueApp.$bvModal.msgBoxConfirm(message, {
            title: 'Please Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        }).then(value => {
            if (value) 
                okFunc();
            else
                noFunc();
        })
    }
    public static msgBoxAlert(message: string, vueApp: Vue, okFunc: () => any) {
        vueApp.$bvModal.msgBoxOk(message).then(value => {
            if (value) okFunc();
        })
    }
    public static CallAjax(url: string, method: Method, app: any, thenFunc: (response: any) => any): void {
        axios({
            method: method,
            url: General.GetApiUrl(url),
            responseType: 'json',
            withCredentials: true
        }).then(function (response) {
            thenFunc(response);
        }).catch(error => {
            if (app != null)
                app.loading = false;
            this.HandleError(error, app);
        });
    }
    private static async Impersonate(userNameToImpersonate: string, app: any, active: boolean, router: any) {
        let impersonatedBy: any = app.$store.state.user;
        let userToImpersonate: string = userNameToImpersonate;
        if (active == false) {
            userNameToImpersonate = app.$store.getters.impersonatedBy.Username;
            let response = await axios.get(General.GetApiUrl('/api/UserProfile/EndImpersonate'), { withCredentials: true })
            if (response.data.response == 299) {                
                let token: string = impersonatedBy.Username;
                let user = {
                    Username: token,
                    IdCulture: response.data.idCulture
                }
                let claims = response.data.claims;
                let isLogged = true;
                let cookieExpiration = response.data.cookieExpiration;
                app.$store.dispatch('login', { token, user, claims, isLogged, cookieExpiration });
                //app.$router.push('/');
            } else {
                app.$fire({
                    //title: "Info",
                    text: response.data.response,
                    type: "error"
                })
            }
        }
        else{
            let response = await axios.get(General.GetApiUrl('/api/Admin/Impersonate?username=' + userNameToImpersonate), { withCredentials: true })
            if (response.data.response == 299) {                
                let token: string = impersonatedBy.Username;
                let claims = response.data.claims;
                let user = General.BuildUser(token,claims, response.data.idCulture);                
                let isLogged = true;
                let cookieExpiration = response.data.cookieExpiration;
                if (active == true) {
                    app.$store.dispatch('impersonate', { token, user, impersonatedBy, userToImpersonate, claims, isLogged, cookieExpiration });
                } else {
                    app.$store.dispatch('login', { token, user, claims, isLogged, cookieExpiration });
                }
                
                General.GoToHomePage(router);
                //app.$router.push('/');
            } else {
                app.$fire({
                    //title: "Info",
                    text: response.data.message,
                    type: "error"
                })
            }
        }
        
    }
    public static async StartImpersonate(userNameToImpersonate: string, app: any, router: any) {
        await General.Impersonate(userNameToImpersonate, app, true, router);
    }
    
    public static async GetUser() {        
       let response = await axios({
            method: 'get',
            url: General.GetApiUrl('/api/userProfile/GetFullUserProfile'),
            responseType: 'json',
            withCredentials: true
       });
        return response;
    }

    public static async SetUser() {        
        let responseFromGet = await General.GetUser();
        if (responseFromGet.data != null) {                        
            let claims = responseFromGet.data.userAuth.claims;
            let userProfile = responseFromGet.data.userProfile;
            store.dispatch('setUserInfo', { userProfile,claims });
        }
    }
    public static async loadLanguageAsync(language: string) {
        await loadLanguageAsync(language);
    }
    public static async loadLanguageFromStoreAsync() {        
        await loadLanguageAsync(store.getters.getUser.IdCulture); 
    }
    public static BuildUser(username:string,claimsList:Array<any>, idCulture: string): IStoreUser{
        const showCommunicationClaim:boolean = (claimsList)?claimsList.find(x => x.claimType == "CanShowCommunications"):false;                   
        let user: IStoreUser = {
            Username: username,
            ShowCommunication: (showCommunicationClaim) ? true : false,
            IdCulture: idCulture
        }

        return user;
    }
    public static GetLimitDateProcessToView():Date{        
        let date = new Date(Date.now());
        
        date.setHours(date.getHours() - process.env.VUE_APP_PROCESS_MAX_TIME_HH);
       
        return date;
        
    }

    public static CommunicationsIsActive(){
        if (store.getters.getFatherCountry==null) return false;       
        if (store.getters.getUserProfile.contractType == 3) return false
        return store.getters.getFatherCountry.showCommunication;
    }

    
    public static GetUserFromStore() {
        if (store.getters.isImpersonated) {
            return store.getters.userToImpersonate;
        }        
        return store.getters.getUser.Username
    }

    public static async GetCountries() {        
        let response = await axios({
            method: 'get',
            url: General.GetApiUrl('/api/culture/getcountries?emptyCountriesPolicy=0&type=COUNTRY_AUTHORITY&ok'),
            withCredentials: true
        });
        return response;
    }
    public static async GetCountriesAll() {        
        let response = await axios({
            method: 'get',
            url: General.GetApiUrl('/api/culture/GetCountriesAll?type=COUNTRY_AUTHORITY'),
            withCredentials: true
        });
        return response;
    }

    public static async EndImpersonate(app: any) {
        await General.Impersonate(null, app, false, null);
        General.setHideCommunication(app, false);
        General.GoToHP();
        
    }

    public static GoToHP(){
        window.location.href="/";
    }

    public static setHideCommunication(app: any, hideCommunicationDuringImpersonation: boolean){
        app.$store.dispatch('setIsHidingCommunicationsDuringImpersonation', hideCommunicationDuringImpersonation);
    }

    public static async GetDropDownItemList(source: string, excludeDeleted: boolean = false): Promise<Array<any>> {
        try{
            let apiUrl = '/api/DropDownItem/GetDropDownItemsBySourceCode?codDropDownSource=' + source
            apiUrl = excludeDeleted ? apiUrl + '&excludeDeleted=true' : apiUrl;

            let response = await axios.get<DropDownItem[]>(
                General.GetApiUrl(apiUrl),{
                responseType: "json",
                withCredentials: true
            });  
        
            return response.data;         
        } catch(ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    public static async GetDropdownList(source: string, excludeDeleted: boolean = false): Promise<Array<any>> {
        try{
            let apiUrl = '/api/DropDownItem/GetDropDownItemsBySourceCode?codDropDownSource=' + source
            apiUrl = excludeDeleted ? apiUrl + '&excludeDeleted=true' : apiUrl;           

            let response = await axios.get<DropDownItem[]>(
                General.GetApiUrl(apiUrl),{
                responseType: "json",
                withCredentials: true
            });
            if(response.data) {
                return General.SetOptionsDropDown(response.data);
            }
                
        } catch(ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    public static SetOptionsDropDown(dropDownItems: DropDownItem[], includeEmptyOption: boolean = true) {
        let array: Array<SelectDropDownItem> = [];
    

        if(includeEmptyOption) {
            let emptyItem = {} as SelectDropDownItem;
            emptyItem.value = null;
            emptyItem.text = "";
            emptyItem.identifyCode = null;
            emptyItem.deletionDate = null;
            
            array.push(emptyItem);
        }
    
        dropDownItems.forEach(function (el) {
            let newItem = {} as SelectDropDownItem;
            newItem.value = el.idDropDownItem;
            newItem.identifyCode = el.identifyCode;
            newItem.deletionDate = el.deletionDate;
            
            if(el.itemText.startsWith('{{'))
                newItem.text = i18n.t(el.itemText.substring(2, el.itemText.length - 2)) as string;
            else
                newItem.text = el.itemText;

            if(el.deletionDate != null)
                newItem.text = newItem.text + ' ' + i18n.t('GENERIC.DELETED_DROPDOWN_LABEL_SUFFIX')

            array.push(newItem);
        });
        return array;
    }
    

    public static getContractTypeDescription(contractType:number): string{
        switch (contractType) {
            case CONTRACT_TYPE_ENUM.INTERNAL:
                return "Internal"
            case CONTRACT_TYPE_ENUM.EXTERNAL:
                return "External"
            case CONTRACT_TYPE_ENUM.OUTER:
                return "Outer"
            default:
                return "Undefined";
        }
    }  
    
    public static async GetEmergencyContactIfExpiredAsync() {
        try {
            let response: any = await axios({
                method: 'GET',
                url: General.GetApiUrl('/api/EmergencyContact/CheckIfEmergencyContactIsExpiredAsync'),
                withCredentials: true,
                responseType: 'json'
            })

            store.commit("SET_ISEMERGENCYCONTACTEXPIRED", response.data);
            return response.data

        } catch (error) {
            General.HandleError(error, this);
            return null
        }
        }
    
}